import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Image } from 'foundations-components/transitional/components/Image';
import { getPublicLang } from 'academy-common-lib/utils/url';
import FormattedMessage from 'I18n/components/FormattedMessage';
// English company logos
// @ts-expect-error Could not find a declaration file for module
import panasonicLogo from 'bender-url!../../../images/homepage/company-logos/Panasonic_Group_logo.png';
// @ts-expect-error Could not find a declaration file for module
import redditLogo from 'bender-url!../../../images/homepage/company-logos/reddit-logo.webp';
// @ts-expect-error Could not find a declaration file for module
import zapierLogo from 'bender-url!../../../images/homepage/company-logos/zapier-logo.png';
// @ts-expect-error Could not find a declaration file for module
import ebayLogo from 'bender-url!../../../images/homepage/company-logos/ebay-logo.png';
// @ts-expect-error Could not find a declaration file for module
import doordashLogo from 'bender-url!../../../images/homepage/company-logos/doordash-logo.png';

// Spanish company logos
// @ts-expect-error Could not find a declaration file for module
import docplannerLogo from 'bender-url!../../../images/homepage/company-logos-es/Docplanner.webp';
// @ts-expect-error Could not find a declaration file for module
import nissanLogo from 'bender-url!../../../images/homepage/company-logos-es/Nissan.svg';
// @ts-expect-error Could not find a declaration file for module
import copaAirlinesLogo from 'bender-url!../../../images/homepage/company-logos-es/Copa-Airlines-blue.svg';
// @ts-expect-error Could not find a declaration file for module
import casioLogo from 'bender-url!../../../images/homepage/company-logos-es/Casio_Logo.png';
// @ts-expect-error Could not find a declaration file for module
import ebanxLogo from 'bender-url!../../../images/homepage/company-logos-es/ebanx.webp';
// @ts-expect-error Could not find a declaration file for module
import nuboxLogo from 'bender-url!../../../images/homepage/company-logos-es/Nubox-1-1.webp';

// French company logos
// @ts-expect-error Could not find a declaration file for module
import laposteLogo from 'bender-url!../../../images/homepage/company-logos/la-poste.png';
// @ts-expect-error Could not find a declaration file for module
import leFigaroLogo from 'bender-url!../../../images/homepage/company-logos/le-figaro.png';
// @ts-expect-error Could not find a declaration file for module
import engieLogo from 'bender-url!../../../images/homepage/company-logos/engie.png';
// @ts-expect-error Could not find a declaration file for module
import ubisoftLogo from 'bender-url!../../../images/homepage/company-logos/ubisoft.png';
// @ts-expect-error Could not find a declaration file for module
import bpceLogo from 'bender-url!../../../images/homepage/company-logos/bpce.png';

// German company logos
// @ts-expect-error Could not find a declaration file for module
import babbelLogo from 'bender-url!../../../images/homepage/company-logos/babbel.png';
// @ts-expect-error Could not find a declaration file for module
import kpmgLogo from 'bender-url!../../../images/homepage/company-logos/kpmg.png';
// @ts-expect-error Could not find a declaration file for module
import helloFreshLogo from 'bender-url!../../../images/homepage/company-logos/hello-fresh.png';
// @ts-expect-error Could not find a declaration file for module
import bayerLogo from 'bender-url!../../../images/homepage/company-logos/bayer.png';

// Japanese company logos
// @ts-expect-error Could not find a declaration file for module
import nikkeiLogo from 'bender-url!../../../images/homepage/company-logos/nikkei.png';
// @ts-expect-error Could not find a declaration file for module
import ricohLogo from 'bender-url!../../../images/homepage/company-logos/ricoh.png';
// @ts-expect-error Could not find a declaration file for module
import nttDataLogo from 'bender-url!../../../images/homepage/company-logos/ntt-data.png';
// @ts-expect-error Could not find a declaration file for module
import ankerLogo from 'bender-url!../../../images/homepage/company-logos/anker.png';
// @ts-expect-error Could not find a declaration file for module
import sansanLogo from 'bender-url!../../../images/homepage/company-logos/sansan.png';

// Portuguese company logos
// @ts-expect-error Could not find a declaration file for module
import ifoodLogo from 'bender-url!../../../images/homepage/company-logos/ifood.png';
// @ts-expect-error Could not find a declaration file for module
import aleloLogo from 'bender-url!../../../images/homepage/company-logos/alelo.svg';
// @ts-expect-error Could not find a declaration file for module
import bocaRosaLogo from 'bender-url!../../../images/homepage/company-logos/boca-rosa.png';
// @ts-expect-error Could not find a declaration file for module
import cortexLogo from 'bender-url!../../../images/homepage/company-logos/cortex.png';
// @ts-expect-error Could not find a declaration file for module
import cuboItauLogo from 'bender-url!../../../images/homepage/company-logos/cubo-itau.webp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LanguageLogoMapping = {
  en: [{
    name: 'Panasonic',
    src: panasonicLogo
  }, {
    name: 'Reddit',
    src: redditLogo
  }, {
    name: 'Zapier',
    src: zapierLogo
  }, {
    name: 'eBay',
    src: ebayLogo
  }, {
    name: 'DoorDash',
    src: doordashLogo
  }],
  es: [{
    name: 'Nubox',
    src: nuboxLogo
  }, {
    name: 'Docplanner',
    src: docplannerLogo
  }, {
    name: 'Copa Airlines',
    src: copaAirlinesLogo
  }, {
    name: 'Casio',
    src: casioLogo
  }, {
    name: 'Nissan',
    src: nissanLogo
  }, {
    name: 'EBANX',
    src: ebanxLogo
  }],
  de: [{
    name: 'Babbel',
    src: babbelLogo
  }, {
    name: 'KPMG',
    src: kpmgLogo
  }, {
    name: 'HelloFresh',
    src: helloFreshLogo
  }, {
    name: 'Bayer',
    src: bayerLogo
  }, {
    name: 'Reddit',
    src: redditLogo
  }],
  ja: [{
    name: 'Nikkei',
    src: nikkeiLogo
  }, {
    name: 'RICOH',
    src: ricohLogo
  }, {
    name: 'NTT data',
    src: nttDataLogo
  }, {
    name: 'Anker',
    src: ankerLogo
  }, {
    name: 'sansan',
    src: sansanLogo
  }],
  fr: [{
    name: 'Laposte Groupe',
    src: laposteLogo
  }, {
    name: 'Le Figaro',
    src: leFigaroLogo
  }, {
    name: 'Engie',
    src: engieLogo
  }, {
    name: 'Ubisoft',
    src: ubisoftLogo
  }, {
    name: 'BPCE',
    src: bpceLogo
  }],
  pt: [{
    name: 'Ifood',
    src: ifoodLogo
  }, {
    name: 'Alelo',
    src: aleloLogo
  }, {
    name: 'Boca rosa',
    src: bocaRosaLogo
  }, {
    name: 'cortex',
    src: cortexLogo
  }, {
    name: 'cubo Itau',
    src: cuboItauLogo
  }]
};
const CustomerLogoBannerSection = () => {
  const currentLang = getPublicLang();
  const companyLogos = LanguageLogoMapping[currentLang];
  return /*#__PURE__*/_jsxs(View, {
    as: "section",
    backgroundColor: "do-not-use-gypsum",
    "data-test-id": "customer-logo-banner-section",
    paddingBlockEnd: "400",
    paddingBlockStart: "1100",
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(H2, {
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.homepage.customerLogoBanner.heading"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
      children: companyLogos.map(company => /*#__PURE__*/_jsx(Box, {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        padding: "500",
        children: /*#__PURE__*/_jsx(Image, {
          alt: company.name,
          height: 20,
          src: company.src,
          width: 80
        })
      }, company.name))
    })]
  });
};
export default CustomerLogoBannerSection;